import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class GlobalExceptionFilter implements ErrorHandler {

  handleError(error: Error | HttpErrorResponse): void {
    if (error instanceof HttpErrorResponse) {
      return;
    }

    if (isDevMode()) {
      console.error('Error captured by GlobalExceptionFilter:', error);
    }
  }
}
